<template>
    <div class="dashboard">
        <h1>ドライバー{{ contents[contentsType].title }}</h1>
        <ValidationObserver ref="observer" v-slot="{ invalid }" tag="div">
            <div class="l-w5 l-2-20-t--all">
                <div>
                    <h2>ドライバーID</h2>
                    <ValidationProvider v-slot="{ errors }" class="l-mt2 l-mb8" name="ドライバーID" rules="integer|max_value:999|min_value:1|required" tag="div" :immediate="$_getValidatedImmediate()">
                        <input v-model="input.driver_id" type="number" :disabled="contents[contentsType].flagDisabled">
                        <p class="errorMessage">{{ errors[0] }}</p>
                    </ValidationProvider>
                    <h2>パスワード</h2>
                    <ValidationProvider v-slot="{ errors }" class="l-mt2 l-mb8" name="パスワード" rules="max:50|required" tag="div" :immediate="$_getValidatedImmediate()">
                        <input v-model="input.driver_password" type="text">
                        <p class="errorMessage">{{ errors[0] }}</p>
                    </ValidationProvider>
                    <h2>ドライバー名</h2>
                    <ValidationProvider v-slot="{ errors }" class="l-mt2 l-mb8" name="ドライバー名" rules="max:10|required" tag="div" :immediate="$_getValidatedImmediate()">
                        <input v-model="input.driver_name" type="text">
                        <p class="errorMessage">{{ errors[0] }}</p>
                    </ValidationProvider>
                    <h2>通常出社時間</h2>
                    <ValidationProvider v-slot="{ errors }" class="l-mt2 l-mb8" name="通常出社時間" rules="required" tag="div" :immediate="$_getValidatedImmediate()">
                        <input v-model="input.work_time" type="time">
                        <p class="errorMessage">{{ errors[0] }}</p>
                    </ValidationProvider>
                </div>
                <div>
                    &nbsp;
                </div>
            </div>
            <div class="l-mt6 l-2-00-m--all">
                <div>
                    <button :class="`${classButtonStyle}cancel`" type="button" @click="$_goBack()">戻る</button>
                    <button :class="X_validatedButtonStyle" type="button" :disabled="$_setValidatedDisabled(invalid)" @click="$_modalOpen(contents[contentsType].modal)">次へ</button>
                </div>
                <div v-if="contents[contentsType].flagShow">
                    <button :class="`${classButtonStyle}delete`" type="button" @click="$_modalOpen('deleteDrivers')">削除する</button>
                </div>
            </div>
        </ValidationObserver>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";

    const contents = {
        "create": {
            "flagDisabled": false,
            "flagShow": false,
            "modal": "createDrivers",
            "title": "登録",
        },
        "update": {
            "flagDisabled": true,
            "flagShow": true,
            "modal": "updateDrivers",
            "title": "編集",
        },
    };

    export default {
        "mixins": [
            common,
        ],
        "props": {
            "id": {
                "default": "",
                "required": false,
                "type": String,
            },
        },
        data() {
            return {
                "classButtonStyle": "button--oval--",
                "contents": contents,
                "contentsType": "create",
                "input": {
                    "driver_id": "",
                    "driver_password": "",
                    "driver_name": "",
                    "work_time": "08:00",
                },
            };
        },
        created() {
            if (this.id) {
                // 登録画面から編集画面へ切り替え
                this.contentsType = "update";
                this.fetchingDataDrivers();
            } else {
                this.$_setValidatedImmediate();
            }
        },
        "methods": {
            modalAction(key) {
                if (key === "createDrivers") {
                    this.handleCreate();
                } else if (key === "updateDrivers") {
                    this.handleUpdate();
                } else if (key === "deleteDrivers") {
                    this.handleDelete();
                } else if (key === "createDrivers--finished" || key === "updateDrivers--finished" || key === "deleteDrivers--finished") {
                    this.$router.push({ "name": "offices_drivers_list" });
                }
            },
            fetchingDataDrivers() {
                // 個別ドライバーデータ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/drivers/${this.id}`,
                    this.$_requestConfig()
                ).then(response => {
                    this.input = response.data;
                }).catch(() => {
                    this.$_modalError("fetchingDriversError");
                });
            },
            handleCreate() {
                // 個別ドライバーデータ作成
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/drivers`,
                    this.input,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
            handleUpdate() {
                // 個別ドライバーデータ編集
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/drivers/${this.id}`,
                    this.input,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
            handleDelete() {
                // 個別ドライバーデータ削除
                common.$_axios.delete(
                    `${common.$_configs.apiUrl}/drivers/${this.id}`,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
        },
    };
</script>
